/**
 * Every screen, in the order the navigation shows them and the number keys
 * count them. Kept apart from register.tsx so a test can read the real list
 * without mounting every screen behind it.
 */

import { Activity, Database, GraduationCap, History, Package, Route, Shield, Target } from 'lucide-react';

import type { ScreenEntry } from './screens';

// Training is planning on a practice fleet, so it is offered to exactly the
// people Planning is offered to.
export const SCREENS: ScreenEntry[] = [
  { id: 'command', label: 'Command', icon: Target },
  { id: 'planning', label: 'Planning', short: 'Plan', icon: Route, requires: 'operator' },
  { id: 'flights', label: 'Flights', icon: History },
  { id: 'health', label: 'Health', icon: Activity },
  { id: 'supply', label: 'Supply', icon: Package },
  { id: 'data', label: 'Data', icon: Database },
  { id: 'admin', label: 'Admin', icon: Shield, requires: 'admin' },
  { id: 'training', label: 'Training', icon: GraduationCap, requires: 'operator' },
];
